import { createUseStyles } from 'react-jss';
export const useTabListStyles = createUseStyles(() => ({
    tabList: {
        borderBottom: '1px solid #E2E4E9',
        width: ({ fullWidth }) => (fullWidth ? '100%' : 'fit-content')
    }
}));
